module.exports = __webpack_public_path__ + "static/img/home_process_tuiguang_4.6343e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_process_tuiguang_4.png
// module id = lFls
// module chunks = 1